'use client'

import { Alert } from '@chakra-ui/react'
import { Button } from '@saas-ui/react'

import { useImpersonation } from '#features/common/hooks/use-impersonation'

export function ImpersonationBanner() {
  const { isImpersonating, impersonatedUser, stopImpersonating } =
    useImpersonation()

  if (!isImpersonating) {
    return null
  }

  return (
    <Alert.Root
      status="info"
      variant="subtle"
      colorPalette="accent"
      borderRadius="0"
      size="sm"
      py="1"
      borderWidth="1px"
    >
      <Alert.Content
        flexDirection="row"
        alignItems="center"
        justifyContent="center"
      >
        <Alert.Title>
          You are impersonating{' '}
          {impersonatedUser?.name || impersonatedUser?.email}
        </Alert.Title>
        <Button
          size="xs"
          variant="subtle"
          colorPalette="accent"
          onClick={stopImpersonating}
        >
          Stop impersonating
        </Button>
      </Alert.Content>
    </Alert.Root>
  )
}
